import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiCall from "./../../API/API";
import Popup from "reactjs-popup";
import { HiDownload } from "react-icons/hi";
import { useDropzone } from "react-dropzone";
import imageCompression from "browser-image-compression";
import { MdOutlineModeEdit } from "react-icons/md";
// import ExportExcel from "../../Component/ExportExcel/ExportExcel";
import { MdArrowBack } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { FaExpandAlt } from "react-icons/fa";
import { FaAngleLeft } from "react-icons/fa";
import { MdOutlineRotate90DegreesCcw } from "react-icons/md";
import { FaAngleRight } from "react-icons/fa";
import "./KycControls.css";

const KycControls = () => {
  const location = useLocation();
  const { username, currentPage, userList = [] } = location.state || {};
  const initialIndex = username ? userList.indexOf(username) : 0;
  const [currentUser, setCurrentUser] = useState(
    username || (userList.length ? userList[0] : "")
  );
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [bankName, setBankName] = useState("");
  const [selectedBankType, setSelectedBankType] = useState("");
  const [holderName, setHolderName] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [address, setAddress] = useState("");
  const [name, setName] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [idDocumentNumber, setIdDocumentNumber] = useState("");
  const [nomineeName, setNomineeName] = useState("");
  const [relationship, setRelationship] = useState("");
  const [selectedNomineeType, setSelectedNomineeType] = useState("");
  const [files, setFiles] = useState([]);
  const [panFiles, setPanFiles] = useState([]);
  const [addressFrontFiles, setAddressFrontFiles] = useState([]);
  const [backFiles, setBackFiles] = useState([]);
  const [previews, setPreviews] = useState({
    bank: [],
    pan: [],
    addressFront: [],
    addressBack: [],
    nomineeFront: [],
    nomineeBack: [],
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [kyc, setKyc] = useState(null);
  const [rejectionReason, setRejectionReason] = useState({
    bank: "",
    pan: "",
    address: "",
    nominee: "",
  });
  const [isBankEdit, setIsBankEdit] = useState(false);
  const [isPanEdit, setIsPanEdit] = useState(false);
  const [isAddressEdit, setIsAddressEdit] = useState(false);
  const [isNomineeEdit, setIsNomineeEdit] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [scale, setScale] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [zoomInput, setZoomInput] = useState(100);

  const handleZoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + 0.1, 3));
    setZoomInput((prev) => Math.min(prev + 10, 300));
  };

  const handleZoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.1, 0));
    setZoomInput((prev) => Math.max(prev - 10, 0));
  };

  const handleZoomInputChange = (e) => {
    const value = Math.min(Math.max(Number(e.target.value), 0), 300);
    setZoomInput(value);
    setScale(value / 100);
  };

  const handleRotate = () => {
    setRotation((prevRotation) => prevRotation + 90);
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseViewer = () => {
    setSelectedImage(null);
  };

  // const [search, setSearch] = useState({
  //   search: username || "",
  // });

  useEffect(() => {
    if (currentUser) {
      fetchKYC(currentUser);
    }
  }, [currentUser]);

  const fetchKYC = async (username) => {
    const filters = Object.fromEntries(
      Object.entries({ search: username }).filter(
        ([key, value]) => value !== ""
      )
    );
    const queryParams = {
      ...filters,
    };
    const queryString = new URLSearchParams(queryParams).toString();
    const { data, error } = await apiCall(
      "GET",
      `/all-kyc-request?${queryString}`,
      null,
      false
    );
    if (error) {
      toast.error(error.message);
    } else {
      setKyc(data?.data[0]);
    }
  };

  const handleFilesChange = (newFiles, type) => {
    if (type === "addressBack" || type === "nomineeBack") {
      setBackFiles(newFiles); // back files
    } else {
      setFiles(newFiles); // front files
    }

    setPreviews((prevPreviews) => ({
      ...prevPreviews,
      [type]: newFiles.map((file) => URL.createObjectURL(file)),
    }));
  };

  const handleBank = async () => {
    try {
      const formData = new FormData();
      formData.append(
        "accountNumber",
        accountNumber || kyc?.bankDetails?.accountNumber
      );
      formData.append("ifscCode", ifscCode || kyc?.bankDetails?.ifscCode);
      formData.append("bankName", bankName || kyc?.bankDetails?.bankName);
      formData.append(
        "accountType",
        selectedBankType || kyc?.bankDetails?.accountType
      );
      formData.append("holderName", holderName || kyc?.bankDetails?.holderName);
      formData.append("uid", kyc?.uid);
      if (files.length > 0) {
        files.forEach((file) => {
          formData.append("document", file);
        });
      } else if (kyc?.bankDetails?.document) {
        formData.append("document", kyc.bankDetails.document);
      }
      console.log("4444444444444444444444444", formData);
      const { data, error } = await apiCall(
        "POST",
        "/update-bank-kyc",
        formData
      );
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Bank details are updated successfully!");
        setIsBankEdit(false);
        fetchKYC(currentUser);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  const handlePan = async () => {
    try {
      const formData = new FormData();
      formData.append("panNumber", panNumber || kyc?.panDetails?.panNumber);
      formData.append("uid", kyc?.uid);

      // Check if panFiles is available and append it to formData
      if (panFiles.length > 0) {
        panFiles.forEach((file) => {
          formData.append("document", file);
        });
      } else if (kyc?.panDetails?.document) {
        formData.append("document", kyc.panDetails.document);
      }

      const { data, error } = await apiCall(
        "POST",
        "/update-pan-kyc",
        formData
      );
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Pan details updated successfully!");
        setIsPanEdit(false);
        fetchKYC(currentUser);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  const handleAddress = async () => {
    try {
      const formData = new FormData();
      formData.append("idType", selectedValue || kyc?.addressDetails?.idType);
      formData.append("idNumber", idNumber || kyc?.addressDetails?.idNumber);
      formData.append("name", name || kyc?.addressDetails?.name);
      formData.append("address", address || kyc?.addressDetails?.address);
      formData.append("uid", kyc?.uid);
      if (addressFrontFiles.length > 0) {
        addressFrontFiles.forEach((addressFrontFiles) => {
          formData.append("documentFront", addressFrontFiles);
        });
      } else if (kyc?.addressDetails?.documentFront) {
        formData.append("documentFront", kyc.addressDetails.documentFront);
      }
      if (backFiles.length > 0) {
        backFiles.forEach((backfile) => {
          formData.append("documentBack", backfile);
        });
      } else if (kyc?.addressDetails?.documentBack) {
        formData.append("documentBack", kyc.addressDetails.documentBack);
      }

      console.log("Sending update for ID Number:", formData.get("idNumber"));

      const { data, error } = await apiCall(
        "POST",
        "/update-address-kyc",
        formData
      );
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(
          data.message || "Address details are updated successfully!"
        );
        setIsAddressEdit(false);
        fetchKYC(currentUser);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  const handleNominee = async () => {
    try {
      const formData = new FormData();

      // Append nominee details with fallback to existing KYC details
      formData.append(
        "idDocumentType",
        selectedNomineeType || kyc?.nomineeDetails?.idDocumentType
      );
      formData.append(
        "idDocumentNumber",
        idDocumentNumber || kyc?.nomineeDetails?.idDocumentNumber
      );
      formData.append(
        "nomineeName",
        nomineeName || kyc?.nomineeDetails?.nomineeName
      );
      formData.append(
        "relationship",
        relationship || kyc?.nomineeDetails?.relationship
      );
      formData.append("uid", kyc?.uid);

      // Handle nominee front document
      if (nomineeFrontFiles.length > 0) {
        formData.append("documentFront", nomineeFrontFiles[0]); // append the first front file
      } else if (kyc?.nomineeDetails?.documentFront) {
        formData.append("documentFront", kyc.nomineeDetails.documentFront); // use existing front file if no new one
      }

      // Handle nominee back document
      if (nomineeBackFiles.length > 0) {
        formData.append("documentBack", nomineeBackFiles[0]); // append the first back file
      } else if (kyc?.nomineeDetails?.documentBack) {
        formData.append("documentBack", kyc.nomineeDetails.documentBack); // use existing back file if no new one
      }

      console.log(
        "Sending update for Nominee ID Document Number:",
        formData.get("idDocumentNumber")
      );

      // API call to update nominee KYC details
      const { data, error } = await apiCall(
        "POST",
        "/update-nominee-kyc",
        formData
      );

      // Handle response and errors
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(
          data.message || "Nominee details are updated successfully!"
        );
        setIsNomineeEdit(false); // Disable edit mode
        fetchKYC(currentUser); // Refresh KYC data
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };
  const onDrop = async (acceptedFiles, type) => {
    const compressedFiles = await Promise.all(
      acceptedFiles.map(async (file) => {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };
        try {
          const compressedFile = await imageCompression(file, options);
          return compressedFile;
        } catch (err) {
          console.error("Error compressing image:", err);
          return file;
        }
      })
    );

    if (type === "pan") {
      setPanFiles(compressedFiles);
      setPreviews((prevPreviews) => ({
        ...prevPreviews,
        pan: compressedFiles.map((file) => URL.createObjectURL(file)),
      }));
    }

    // Front and back files need to be stored separately to avoid overwriting
    if (type === "addressFront") {
      setAddressFrontFiles(compressedFiles); // address front files
      setPreviews((prevPreviews) => ({
        ...prevPreviews,
        addressFront: compressedFiles.map((file) => URL.createObjectURL(file)),
      }));
    } else if (type === "addressBack") {
      setBackFiles(compressedFiles); // address back files
      setPreviews((prevPreviews) => ({
        ...prevPreviews,
        addressBack: compressedFiles.map((file) => URL.createObjectURL(file)),
      }));
    } else if (type === "nomineeFront") {
      setNomineeFrontFiles(compressedFiles); // nominee front files
      setPreviews((prevPreviews) => ({
        ...prevPreviews,
        nomineeFront: compressedFiles.map((file) => URL.createObjectURL(file)),
      }));
    } else if (type === "nomineeBack") {
      setNomineeBackFiles(compressedFiles); // nominee back files
      setPreviews((prevPreviews) => ({
        ...prevPreviews,
        nomineeBack: compressedFiles.map((file) => URL.createObjectURL(file)),
      }));
    } else {
      handleFilesChange(compressedFiles, type); // for other cases
    }
  };

  const [nomineeFrontFiles, setNomineeFrontFiles] = useState([]);
  const [nomineeBackFiles, setNomineeBackFiles] = useState([]);

  const { getRootProps: getBankRootProps, getInputProps: getBankInputProps } =
    useDropzone({ onDrop: (acceptedFiles) => onDrop(acceptedFiles, "bank") });

  const { getRootProps: getPanRootProps, getInputProps: getPanInputProps } =
    useDropzone({
      onDrop: (acceptedFiles) => onDrop(acceptedFiles, "pan"),
    });

  const {
    getRootProps: getAddressFrontRootProps,
    getInputProps: getAddressFrontInputProps,
  } = useDropzone({
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, "addressFront"),
  });

  const {
    getRootProps: getAddressBackRootProps,
    getInputProps: getAddressBackInputProps,
  } = useDropzone({
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, "addressBack"),
  });

  const {
    getRootProps: getNomineeFrontRootProps,
    getInputProps: getNomineeFrontInputProps,
  } = useDropzone({
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, "nomineeFront"),
  });

  const {
    getRootProps: getNomineeBackRootProps,
    getInputProps: getNomineeBackInputProps,
  } = useDropzone({
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, "nomineeBack"),
  });

  const handleApprove = async (uid, kycType) => {
    try {
      const { data, error } = await apiCall("POST", "/approve-kyc-request", {
        uid,
        kycType,
      });
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Request Approved");
        fetchKYC(currentUser);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  const handleReject = async (uid, kycType) => {
    try {
      const { data, error } = await apiCall("POST", "/reject-kyc-request", {
        uid,
        kycType,
        reason: rejectionReason[kycType],
      });
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Request Rejected");
        fetchKYC(currentUser);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  const handleGoBack = () => {
    navigate("/dashboard/kyc_detail", {
      state: { currentPage },
    });
  };

  const handleNext = () => {
    if (currentIndex < userList.length - 1) {
      const nextUsername = userList[currentIndex + 1];
      navigate("/dashboard/kyc_controls", {
        state: {
          username: nextUsername,
          currentPage,
          userList,
        },
      });
      setCurrentUser(nextUsername);
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      const prevUsername = userList[currentIndex - 1];
      navigate("/dashboard/kyc_controls", {
        state: {
          username: prevUsername,
          currentPage,
          userList,
        },
      });
      setCurrentUser(prevUsername);
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <React.Fragment>
      <Container>
        <div className={`details-table ${selectedImage ? "shifted" : ""}`}>
          <div onClick={handleGoBack} className="backButton">
            <MdArrowBack size={22} style={{ marginRight: "3px" }} />
            <span>Back</span>
          </div>
          <div className="content">
            <h3>KYC Details</h3>
            <div className="prevNext">
              <Button onClick={handlePrevious} disabled={currentIndex === 0}>
                Prev
              </Button>
              <Button
                onClick={handleNext}
                disabled={currentIndex === userList?.length - 1}
              >
                Next
              </Button>
            </div>
            <hr />
            <Row id="directTabRow">
              {" "}
              <Col xs="12" sm="12" md="12" lg="12">
                <div className="table-responsive">
                  <h4>User Details</h4>
                  <table className="detailTable">
                    {" "}
                    <tbody>
                      <tr>
                        <th>Name</th>
                        <td>:</td>
                        <td>{kyc?.name}</td>
                      </tr>
                      <tr>
                        {" "}
                        <th>Username</th>
                        <td>:</td>
                        <td>{kyc?.username}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>

            <Row id="directTabRow">
              <Col xs="12" sm="12" md="8" lg="8">
                <div className="table-responsive">
                  <h4>Bank Details</h4>
                  {isBankEdit ? (
                    <>
                      <table className="detailTable">
                        <tbody>
                          <tr>
                            <th>Bank Name</th>
                            <td>:</td>
                            <td>
                              {" "}
                              <input
                                type="text"
                                className="kyc-input"
                                value={bankName || kyc?.bankDetails?.bankName}
                                onChange={(e) => setBankName(e.target.value)}
                                required
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>IFSC Code</th>
                            <td>:</td>
                            <td>
                              <input
                                type="text"
                                className="kyc-input"
                                value={ifscCode || kyc?.bankDetails?.ifscCode}
                                onChange={(e) =>
                                  setIfscCode(e.target.value.toUpperCase())
                                }
                                required
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Account No</th>
                            <td>:</td>
                            <td>
                              <input
                                type="number"
                                className="kyc-input"
                                value={
                                  accountNumber ||
                                  kyc?.bankDetails?.accountNumber
                                }
                                onChange={(e) =>
                                  setAccountNumber(e.target.value)
                                }
                                required
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Bank Type</th>
                            <td>:</td>
                            <td>
                              <select
                                className="kyc-select"
                                value={
                                  selectedBankType ||
                                  kyc?.bankDetails?.accountType
                                }
                                onChange={(e) =>
                                  setSelectedBankType(e.target.value)
                                }
                              >
                                <option>Choose Bank Type</option>
                                <option value="Saving">Saving</option>
                                <option value="Current">Current</option>
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <th>Holder Name</th>
                            <td>:</td>
                            <td>
                              <input
                                type="text"
                                className="kyc-input"
                                value={
                                  holderName || kyc?.bankDetails?.holderName
                                }
                                onChange={(e) => setHolderName(e.target.value)}
                                required
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Upload Document</th>
                            <td>:</td>
                            <td>
                              {" "}
                              <div className="file-upload-container">
                                <div
                                  {...getBankRootProps({
                                    className: "dropzone",
                                  })}
                                >
                                  <input {...getBankInputProps()} />
                                  <p>
                                    Drag 'n' drop bank document here, or click
                                    to select one
                                  </p>
                                </div>

                                {previews.bank.length > 0 ? (
                                  previews.bank.map((url, index) => (
                                    <img
                                      key={index}
                                      src={url}
                                      alt={`preview-${index}`}
                                      style={{
                                        width: 150,
                                        height: 100,
                                        margin: 10,
                                      }}
                                    />
                                  ))
                                ) : kyc?.bankDetails?.document ? (
                                  <img
                                    src={kyc?.bankDetails.document}
                                    alt="Bank Document"
                                    style={{
                                      width: 150,
                                      height: 100,
                                      margin: 10,
                                    }}
                                  />
                                ) : null}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  ) : kyc?.bankDetails?.bankName ||
                    kyc?.bankDetails?.ifscCode ||
                    kyc?.bankDetails?.accountNumber ||
                    kyc?.bankDetails?.accountType ||
                    kyc?.bankDetails?.holderName ||
                    kyc?.bankDetails?.document ? (
                    <table className="detailTable">
                      <tbody>
                        <tr>
                          <th>Bank Name</th>
                          <td>:</td>
                          <td>{kyc?.bankDetails?.bankName}</td>
                        </tr>
                        <tr>
                          <th>IFSC Code</th>
                          <td>:</td>
                          <td>{kyc?.bankDetails?.ifscCode}</td>
                        </tr>
                        <tr>
                          <th>Account No</th>
                          <td>:</td>
                          <td>{kyc?.bankDetails?.accountNumber}</td>
                        </tr>
                        <tr>
                          <th>Account Type</th>
                          <td>:</td>
                          <td>{kyc?.bankDetails?.accountType}</td>
                        </tr>
                        <tr>
                          <th>Holder Name</th>
                          <td>:</td>
                          <td>{kyc?.bankDetails?.holderName}</td>
                        </tr>
                        <tr>
                          <th>Document</th>
                          <td>:</td>
                          <td>
                            <img
                              src={kyc?.bankDetails?.document}
                              alt="Document"
                              style={{
                                maxWidth: "100px",
                                maxHeight: "100px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleImageClick(kyc?.bankDetails?.document)
                              }
                            />
                            <Popup
                              trigger={
                                <button className="block">
                                  <FaExpandAlt />
                                </button>
                              }
                              modal
                              closeOnDocumentClick
                            >
                              {(close) => (
                                <div className="popup-content">
                                  <button className="close-btn" onClick={close}>
                                    &times;
                                  </button>
                                  <img
                                    src={kyc?.bankDetails?.document}
                                    alt="proof"
                                    className="popImg"
                                  />
                                  <button
                                    className="download-btn"
                                    onClick={() => {
                                      const link = document.createElement("a");
                                      link.href = kyc?.bankDetails?.document;
                                      link.download = "proof.jpg";
                                      link.click();
                                    }}
                                  >
                                    <HiDownload />
                                  </button>{" "}
                                </div>
                              )}
                            </Popup>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <p>No details found.</p>
                  )}
                </div>
              </Col>
              <Col xs="12" sm="12" md="4" lg="4">
                {!isBankEdit ? (
                  <Button
                    variant="primary"
                    onClick={() => setIsBankEdit(true)}
                    style={{ padding: "0px 5px 2px 5px" }}
                    className="editBtn"
                  >
                    <MdEdit />
                  </Button>
                ) : isBankEdit ? (
                  <>
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        handleBank();
                      }}
                      className="editBtn"
                    >
                      Save
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={() => setIsBankEdit(false)}
                      className="editBtn"
                    >
                      Cancel
                    </Button>
                  </>
                ) : null}
                {kyc?.isApproved?.bank == 1 ? (
                  <>
                    <form>
                      <div className="form-group">
                        <label>Reason (Give Reason for cancellation)</label>
                        <textarea
                          className="kyc-input"
                          value={rejectionReason.bank}
                          onChange={(e) =>
                            setRejectionReason({
                              ...rejectionReason,
                              bank: e.target.value,
                            })
                          }
                        ></textarea>
                        <small className="text-muted"></small>
                      </div>
                      <div className="form-group">
                        <button
                          className="action-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleApprove(kyc?.uid, "bank");
                          }}
                        >
                          Approve
                        </button>
                        <button
                          className="action-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleReject(kyc?.uid, "bank");
                          }}
                        >
                          Reject
                        </button>
                      </div>
                    </form>
                  </>
                ) : kyc?.isApproved?.bank == 2 ? (
                  <p id="KycDetail" style={{ color: "green" }}>
                    Approved
                  </p>
                ) : kyc?.isApproved?.bank == 3 ? (
                  <>
                    <p id="KycDetail" style={{ color: "red" }}>
                      Rejected
                    </p>
                    <p>Reason: {kyc?.bankDetails?.reason}</p>
                  </>
                ) : (
                  <p id="KycDetail">Pending</p>
                )}
              </Col>
            </Row>
            <Row id="directTabRow">
              <Col xs="12" sm="12" md="8" lg="8">
                <div className="table-responsive">
                  <h4>PAN Details</h4>
                  {isPanEdit ? (
                    <>
                      {" "}
                      <table className="detailTable">
                        <tbody>
                          <tr>
                            <th>PAN No</th>
                            <td>:</td>
                            <td>
                              <input
                                type="text"
                                className="kyc-input"
                                value={panNumber || kyc?.panDetails?.panNumber}
                                onChange={(e) =>
                                  setPanNumber(e.target.value.toUpperCase())
                                }
                                required
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Document</th>
                            <td>:</td>
                            <td>
                              <div className="file-upload-container">
                                <div
                                  {...getPanRootProps({
                                    className: "dropzone",
                                  })}
                                >
                                  <input {...getPanInputProps()} />
                                  <p>
                                    Drag 'n' drop pan document here, or click to
                                    select one
                                  </p>
                                </div>

                                {previews?.pan?.length > 0 ? (
                                  previews?.pan?.map((url, index) => (
                                    <img
                                      key={index}
                                      src={url}
                                      alt={`preview-${index}`}
                                      style={{
                                        width: 150,
                                        height: 100,
                                        margin: 10,
                                      }}
                                    />
                                  ))
                                ) : kyc?.panDetails?.document ? (
                                  <img
                                    src={kyc?.panDetails?.document}
                                    alt="Pan Document"
                                    style={{
                                      width: 150,
                                      height: 100,
                                      margin: 10,
                                    }}
                                  />
                                ) : null}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  ) : kyc?.panDetails?.panNumber ||
                    kyc?.panDetails?.document ? (
                    <table className="detailTable">
                      <tbody>
                        <tr>
                          <th>PAN No</th>
                          <td>:</td>
                          <td>{kyc?.panDetails?.panNumber}</td>
                        </tr>
                        <tr>
                          <th>Document</th>
                          <td>:</td>
                          <td>
                            <img
                              src={kyc?.panDetails?.document}
                              alt="Document"
                              style={{
                                maxWidth: "100px",
                                maxHeight: "100px",
                                cursor: " pointer",
                              }}
                              onClick={() =>
                                handleImageClick(kyc?.panDetails?.document)
                              }
                            />
                            <Popup
                              trigger={
                                <button className="block">
                                  <FaExpandAlt />
                                </button>
                              }
                              modal
                              closeOnDocumentClick
                            >
                              {(close) => (
                                <div className="popup-content">
                                  <button className="close-btn" onClick={close}>
                                    &times;
                                  </button>
                                  <img
                                    src={kyc?.panDetails?.document}
                                    alt="proof"
                                    className="popImg"
                                  />
                                  <button
                                    className="download-btn"
                                    onClick={() => {
                                      const link = document.createElement("a");
                                      link.href = kyc?.panDetails?.document;
                                      link.download = "proof.jpg";
                                      link.click();
                                    }}
                                  >
                                    <HiDownload />
                                  </button>{" "}
                                </div>
                              )}
                            </Popup>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <p>No details found</p>
                  )}
                </div>
              </Col>
              <Col xs="12" sm="12" md="4" lg="4">
                {!isPanEdit ? (
                  <Button
                    variant="primary"
                    onClick={() => setIsPanEdit(true)}
                    style={{ padding: "0px 5px 2px 5px" }}
                    className="editBtn"
                  >
                    <MdEdit />
                  </Button>
                ) : isPanEdit ? (
                  <>
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePan();
                      }}
                      className="editBtn"
                    >
                      Save
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={() => setIsPanEdit(false)}
                      className="editBtn"
                    >
                      Cancel
                    </Button>
                  </>
                ) : null}

                {kyc?.isApproved?.pan == 1 ? (
                  <>
                    <form>
                      <div className="form-group">
                        <label>Reason (Give Reason for cancellation)</label>
                        <textarea
                          className="kyc-input"
                          value={rejectionReason.pan}
                          onChange={(e) =>
                            setRejectionReason({
                              ...rejectionReason,
                              pan: e.target.value,
                            })
                          }
                        ></textarea>
                        <small className="text-muted"></small>
                      </div>
                      <div className="form-group">
                        <button
                          className="action-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleApprove(kyc?.uid, "pan");
                          }}
                        >
                          Approve
                        </button>
                        <button
                          className="action-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleReject(kyc?.uid, "pan");
                          }}
                        >
                          Reject
                        </button>
                      </div>
                    </form>
                  </>
                ) : kyc?.isApproved?.pan == 2 ? (
                  <p id="KycDetail" style={{ color: "green" }}>
                    Approved
                  </p>
                ) : kyc?.isApproved?.pan == 3 ? (
                  <>
                    <p id="KycDetail" style={{ color: "red" }}>
                      Rejected
                    </p>
                    <p>Reason: {kyc?.panDetails?.reason}</p>
                  </>
                ) : (
                  <p id="KycDetail">Pending</p>
                )}
              </Col>
            </Row>
            <Row id="directTabRow">
              <Col xs="12" sm="12" md="8" lg="8">
                <div className="table-responsive">
                  <h4>Address Details</h4>
                  {isAddressEdit ? (
                    <>
                      <table className="detailTable">
                        <tbody>
                          <tr>
                            <th>ID Type</th>
                            <td>:</td>
                            <td>
                              <select
                                className="kyc-select"
                                value={
                                  selectedValue || kyc?.addressDetails?.idType
                                }
                                onChange={(e) =>
                                  setSelectedValue(e.target.value)
                                }
                                required
                              >
                                <option value="">Choose ID Type</option>
                                <option value="Adhar Card">Aadhaar</option>
                                <option value="Passport">Passport</option>
                                <option value="Driver License">
                                  Driver License
                                </option>
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <th>ID Number</th>
                            <td>:</td>
                            <td>
                              <input
                                type="text"
                                className="kyc-input"
                                value={
                                  idNumber || kyc?.addressDetails?.idNumber
                                }
                                onChange={(e) =>
                                  setIdNumber(e.target.value.toUpperCase())
                                }
                                required
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Name</th>
                            <td>:</td>
                            <td>
                              <input
                                type="text"
                                className="kyc-input"
                                value={name || kyc?.addressDetails?.name}
                                required
                                onChange={(e) => setName(e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Address</th>
                            <td>:</td>
                            <td>
                              {" "}
                              <input
                                type="text"
                                className="kyc-input"
                                value={address || kyc?.addressDetails?.address}
                                onChange={(e) => setAddress(e.target.value)}
                                required
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Upload Document(Front)</th>
                            <td>:</td>
                            <td>
                              {" "}
                              <div className="file-upload-container">
                                <div
                                  {...getAddressFrontRootProps({
                                    className: "dropzone",
                                  })}
                                >
                                  <input {...getAddressFrontInputProps()} />
                                  <p>
                                    Drag 'n' drop Address front document here,
                                    or click to select one
                                  </p>
                                </div>
                                {previews.addressFront.length > 0 ? (
                                  previews.addressFront.map((url, index) => (
                                    <img
                                      key={index}
                                      src={url}
                                      alt={`preview-${index}`}
                                      style={{
                                        width: 150,
                                        height: 100,
                                        margin: 10,
                                      }}
                                    />
                                  ))
                                ) : (
                                  <img
                                    src={kyc?.addressDetails?.documentFront}
                                    alt="address-front-preview"
                                    style={{
                                      width: 150,
                                      height: 100,
                                      margin: 10,
                                    }}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>Upload Document(Back)</th>
                            <td>:</td>
                            <td>
                              {" "}
                              <div className="file-upload-container">
                                <div
                                  {...getAddressBackRootProps({
                                    className: "dropzone",
                                  })}
                                >
                                  <input {...getAddressBackInputProps()} />
                                  <p>
                                    Drag 'n' drop Address back document here, or
                                    click to select one
                                  </p>
                                </div>
                                {previews.addressBack.length > 0 ? (
                                  previews.addressBack.map((url, index) => (
                                    <img
                                      key={index}
                                      src={url}
                                      alt={`preview-${index}`}
                                      style={{
                                        width: 150,
                                        height: 100,
                                        margin: 10,
                                      }}
                                    />
                                  ))
                                ) : (
                                  <img
                                    src={kyc?.addressDetails?.documentBack}
                                    alt="document-back-preview"
                                    style={{
                                      width: 150,
                                      height: 100,
                                      margin: 10,
                                    }}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  ) : kyc?.addressDetails?.name ||
                    kyc?.addressDetails?.address ||
                    kyc?.addressDetails?.idType ||
                    kyc?.addressDetails?.idNumber ||
                    kyc?.addressDetails?.documentFront ||
                    kyc?.addressDetails?.documentBack ? (
                    <>
                      <table className="detailTable">
                        <tbody>
                          <tr>
                            <th>ID Type</th>
                            <td>:</td>
                            <td>{kyc?.addressDetails?.idType}</td>
                          </tr>
                          <tr>
                            <th>ID No.</th>
                            <td>:</td>
                            <td>{kyc?.addressDetails?.idNumber}</td>
                          </tr>
                          <tr>
                            <th>Name</th>
                            <td>:</td>
                            <td>{kyc?.addressDetails?.name}</td>
                          </tr>
                          <tr>
                            <th>Address</th>
                            <td>:</td>
                            <td style={{ width: "50%" }}>
                              {kyc?.addressDetails?.address}
                            </td>
                          </tr>

                          <tr>
                            <th>Document Front</th>
                            <td>:</td>
                            <td>
                              <img
                                src={kyc?.addressDetails?.documentFront}
                                alt="Document"
                                style={{
                                  maxWidth: "100px",
                                  maxHeight: "100px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleImageClick(
                                    kyc?.addressDetails?.documentFront
                                  )
                                }
                              />
                              <Popup
                                trigger={
                                  <button className="block">
                                    <FaExpandAlt />
                                  </button>
                                }
                                modal
                                closeOnDocumentClick
                              >
                                {(close) => (
                                  <div className="popup-content">
                                    <button
                                      className="close-btn"
                                      onClick={close}
                                    >
                                      &times;
                                    </button>
                                    <img
                                      src={kyc?.addressDetails?.documentFront}
                                      alt="proof"
                                      className="popImg"
                                    />
                                    <button
                                      className="download-btn"
                                      onClick={() => {
                                        const link =
                                          document.createElement("a");
                                        link.href =
                                          kyc?.addressDetails?.documentFront;
                                        link.download = "proof.jpg";
                                        link.click();
                                      }}
                                    >
                                      <HiDownload />
                                    </button>{" "}
                                  </div>
                                )}
                              </Popup>
                            </td>
                          </tr>
                          <tr>
                            <th>Document Back</th>
                            <td>:</td>
                            <td>
                              <img
                                src={kyc?.addressDetails?.documentBack}
                                alt="Document"
                                style={{
                                  maxWidth: "100px",
                                  maxHeight: "100px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleImageClick(
                                    kyc?.addressDetails?.documentBack
                                  )
                                }
                              />
                              <Popup
                                trigger={
                                  <button className="block">
                                    <FaExpandAlt />
                                  </button>
                                }
                                modal
                                closeOnDocumentClick
                              >
                                {(close) => (
                                  <div className="popup-content">
                                    <button
                                      className="close-btn"
                                      onClick={close}
                                    >
                                      &times;
                                    </button>
                                    <img
                                      src={kyc?.addressDetails?.documentBack}
                                      alt="proof"
                                      className="popImg"
                                    />
                                    <button
                                      className="download-btn"
                                      onClick={() => {
                                        const link =
                                          document.createElement("a");
                                        link.href =
                                          kyc?.addressDetails?.documentBack;
                                        link.download = "proof.jpg";
                                        link.click();
                                      }}
                                    >
                                      <HiDownload />
                                    </button>{" "}
                                  </div>
                                )}
                              </Popup>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <p>No details found</p>
                  )}
                </div>
              </Col>
              <Col xs="12" sm="12" md="4" lg="4">
                {!isAddressEdit ? (
                  <Button
                    variant="primary"
                    onClick={() => setIsAddressEdit(true)}
                    style={{ padding: "0px 5px 2px 5px" }}
                    className="editBtn"
                  >
                    <MdEdit />
                  </Button>
                ) : isAddressEdit ? (
                  <>
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        handleAddress();
                      }}
                      className="editBtn"
                    >
                      Save
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={() => setIsAddressEdit(false)}
                      className="editBtn"
                    >
                      Cancel
                    </Button>
                  </>
                ) : null}
                {kyc?.isApproved?.address == 1 ? (
                  <>
                    <form>
                      <div className="form-group">
                        <label>Reason (Give Reason for cancellation)</label>
                        <textarea
                          className="kyc-input"
                          value={rejectionReason.address}
                          onChange={(e) =>
                            setRejectionReason({
                              ...rejectionReason,
                              address: e.target.value,
                            })
                          }
                        ></textarea>
                        <small className="text-muted"></small>
                      </div>
                      <div className="form-group">
                        <button
                          className="action-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleApprove(kyc?.uid, "address");
                          }}
                        >
                          Approve
                        </button>
                        <button
                          className="action-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleReject(kyc?.uid, "address");
                          }}
                        >
                          Reject
                        </button>
                      </div>
                    </form>
                  </>
                ) : kyc?.isApproved?.address == 2 ? (
                  <p id="KycDetail" style={{ color: "green" }}>
                    Approved
                  </p>
                ) : kyc?.isApproved?.address == 3 ? (
                  <>
                    <p id="KycDetail" style={{ color: "red" }}>
                      Rejected
                    </p>
                    <p>Reason: {kyc?.addressDetails?.reason}</p>
                  </>
                ) : (
                  <p id="KycDetail">Pending</p>
                )}
              </Col>
            </Row>
            <Row id="directTabRow">
              <Col xs="12" sm="12" md="8" lg="8">
                <div className="table-responsive">
                  <h4>Nominee Details</h4>
                  {isNomineeEdit ? (
                    <>
                      <table className="detailTable">
                        <tbody>
                          <tr>
                            <th>ID Type</th>
                            <td>:</td>
                            <td>
                              <select
                                className="kyc-select"
                                value={
                                  selectedNomineeType ||
                                  kyc?.nomineeDetails?.idDocumentType
                                }
                                onChange={(e) =>
                                  setSelectedNomineeType(e.target.value)
                                }
                                required
                              >
                                <option value="">Choose ID Type</option>
                                <option value="Adhar Card">Aadhaar</option>
                                <option value="Passport">Passport</option>
                                <option value="Driving License">
                                  Driving License
                                </option>
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <th>ID Number</th>
                            <td>:</td>
                            <td>
                              <input
                                type="text"
                                className="kyc-input"
                                value={
                                  idDocumentNumber ||
                                  kyc?.nomineeDetails?.idDocumentNumber
                                }
                                onChange={(e) =>
                                  setIdDocumentNumber(
                                    e.target.value.toUpperCase()
                                  )
                                }
                                required
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Nominee Name</th>
                            <td>:</td>
                            <td style={{ width: "50%" }}>
                              <input
                                type="text"
                                className="kyc-input"
                                value={
                                  nomineeName ||
                                  kyc?.nomineeDetails?.nomineeName
                                }
                                required
                                onChange={(e) => setNomineeName(e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Relationship</th>
                            <td>:</td>
                            <td>
                              <input
                                type="text"
                                className="kyc-input"
                                value={
                                  relationship ||
                                  kyc?.nomineeDetails?.relationship
                                }
                                onChange={(e) =>
                                  setRelationship(e.target.value)
                                }
                                required
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Upload Document(Front)</th>
                            <td>:</td>
                            <td>
                              <div className="file-upload-container">
                                <div
                                  {...getNomineeFrontRootProps({
                                    className: "dropzone",
                                  })}
                                >
                                  <input {...getNomineeFrontInputProps()} />
                                  <p>
                                    Drag 'n' drop Nominee front document here,
                                    or click to select one
                                  </p>
                                </div>
                                {previews.nomineeFront.length > 0 ? (
                                  previews.nomineeFront.map((url, index) => (
                                    <img
                                      key={index}
                                      src={url}
                                      alt={`preview-${index}`}
                                      style={{
                                        width: 150,
                                        height: 100,
                                        margin: 10,
                                      }}
                                    />
                                  ))
                                ) : (
                                  <img
                                    src={kyc?.nomineeDetails?.documentFront}
                                    alt="nominee-front-preview"
                                    style={{
                                      width: 150,
                                      height: 100,
                                      margin: 10,
                                    }}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>Upload Document(Back)</th>
                            <td>:</td>
                            <td>
                              <div className="file-upload-container">
                                <div
                                  {...getNomineeBackRootProps({
                                    className: "dropzone",
                                  })}
                                >
                                  <input {...getNomineeBackInputProps()} />
                                  <p>
                                    Drag 'n' drop Nominee back document here, or
                                    click to select one
                                  </p>
                                </div>
                                {previews.nomineeBack.length > 0 ? (
                                  previews.nomineeBack.map((url, index) => (
                                    <img
                                      key={index}
                                      src={url}
                                      alt={`preview-${index}`}
                                      style={{
                                        width: 150,
                                        height: 100,
                                        margin: 10,
                                      }}
                                    />
                                  ))
                                ) : (
                                  <img
                                    src={kyc?.nomineeDetails?.documentBack}
                                    alt="nominee-back-preview"
                                    style={{
                                      width: 150,
                                      height: 100,
                                      margin: 10,
                                    }}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  ) : kyc?.nomineeDetails?.nomineeName ||
                    kyc?.nomineeDetails?.relationship ||
                    kyc?.nomineeDetails?.idDocumentType ||
                    kyc?.nomineeDetails?.idDocumentNumber ||
                    kyc?.nomineeDetails?.documentFront ||
                    kyc?.nomineeDetails?.documentBack ? (
                    <table className="detailTable">
                      <tbody>
                        <tr>
                          <th>ID Type</th>
                          <td>:</td>
                          <td>{kyc?.nomineeDetails?.idDocumentType}</td>
                        </tr>
                        <tr>
                          <th>ID No.</th>
                          <td>:</td>
                          <td>{kyc?.nomineeDetails?.idDocumentNumber}</td>
                        </tr>
                        <tr>
                          <th>Nominee Name</th>
                          <td>:</td>
                          <td>{kyc?.nomineeDetails?.nomineeName}</td>
                        </tr>
                        <tr>
                          <th>Relationship</th>
                          <td>:</td>
                          <td>{kyc?.nomineeDetails?.relationship}</td>
                        </tr>

                        <tr>
                          <th>Document Front</th>
                          <td>:</td>
                          <td>
                            <img
                              src={kyc?.nomineeDetails?.documentFront}
                              alt="Document"
                              style={{
                                maxWidth: "100px",
                                maxHeight: "100px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleImageClick(
                                  kyc?.nomineeDetails?.documentFront
                                )
                              }
                            />
                            <Popup
                              trigger={
                                <button className="block">
                                  <FaExpandAlt />
                                </button>
                              }
                              modal
                              closeOnDocumentClick
                            >
                              {(close) => (
                                <div className="popup-content">
                                  <button className="close-btn" onClick={close}>
                                    &times;
                                  </button>
                                  <img
                                    src={kyc?.nomineeDetails?.documentFront}
                                    alt="proof"
                                    className="popImg"
                                  />
                                  <button
                                    className="download-btn"
                                    onClick={() => {
                                      const link = document.createElement("a");
                                      link.href =
                                        kyc?.nomineeDetails?.documentFront;
                                      link.download = "proof.jpg";
                                      link.click();
                                    }}
                                  >
                                    <HiDownload />
                                  </button>{" "}
                                </div>
                              )}
                            </Popup>
                          </td>
                        </tr>
                        <tr>
                          <th>Document Back</th>
                          <td>:</td>
                          <td>
                            <img
                              src={kyc?.nomineeDetails?.documentBack}
                              alt="Document"
                              style={{
                                maxWidth: "100px",
                                maxHeight: "100px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleImageClick(
                                  kyc?.nomineeDetails?.documentBack
                                )
                              }
                            />
                            <Popup
                              trigger={
                                <button className="block">
                                  <FaExpandAlt />
                                </button>
                              }
                              modal
                              closeOnDocumentClick
                            >
                              {(close) => (
                                <div className="popup-content">
                                  <button className="close-btn" onClick={close}>
                                    &times;
                                  </button>
                                  <img
                                    src={kyc?.nomineeDetails?.documentBack}
                                    alt="proof"
                                    className="popImg"
                                  />
                                  <button
                                    className="download-btn"
                                    onClick={() => {
                                      const link = document.createElement("a");
                                      link.href =
                                        kyc?.nomineeDetails?.documentBack;
                                      link.download = "proof.jpg";
                                      link.click();
                                    }}
                                  >
                                    <HiDownload />
                                  </button>{" "}
                                </div>
                              )}
                            </Popup>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <p>No details found</p>
                  )}
                </div>
              </Col>
              <Col xs="12" sm="12" md="4" lg="4">
                {!isNomineeEdit ? (
                  <Button
                    variant="primary"
                    onClick={() => setIsNomineeEdit(true)}
                    style={{ padding: "0px 5px 2px 5px" }}
                    className="editBtn"
                  >
                    <MdEdit />
                  </Button>
                ) : isNomineeEdit ? (
                  <>
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        handleNominee();
                      }}
                      className="editBtn"
                    >
                      Save
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={() => setIsNomineeEdit(false)}
                      className="editBtn"
                    >
                      Cancel
                    </Button>
                  </>
                ) : null}
                {kyc?.isApproved?.nominee == 1 ? (
                  <>
                    <form>
                      <div className="form-group">
                        <label>Reason (Give Reason for cancellation)</label>
                        <textarea
                          className="kyc-input"
                          value={rejectionReason.nominee}
                          onChange={(e) =>
                            setRejectionReason({
                              ...rejectionReason,
                              nominee: e.target.value,
                            })
                          }
                        ></textarea>
                        <small className="text-muted"></small>
                      </div>
                      <div className="form-group">
                        <button
                          className="action-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleApprove(kyc?.uid, "nominee");
                          }}
                        >
                          Approve
                        </button>
                        <button
                          className="action-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleReject(kyc?.uid, "nominee");
                          }}
                        >
                          Reject
                        </button>
                      </div>
                    </form>
                  </>
                ) : kyc?.isApproved?.nominee == 2 ? (
                  <p id="KycDetail" style={{ color: "green" }}>
                    Approved
                  </p>
                ) : kyc?.isApproved?.nominee == 3 ? (
                  <>
                    <p id="KycDetail" style={{ color: "red" }}>
                      Rejected
                    </p>
                    <p>Reason: {kyc?.nomineeDetails?.reason}</p>
                  </>
                ) : (
                  <p id="KycDetail">Pending</p>
                )}
              </Col>
            </Row>
          </div>
        </div>
        {selectedImage && (
          <div className="side-image-viewer">
            <button className="close-btn2" onClick={handleCloseViewer}>
              &times;
            </button>

            <div className="zoom-rotate-controls">
              <button className="zoom-button" onClick={handleZoomOut}>
                -
              </button>
              <input
                type="number"
                value={zoomInput}
                onChange={handleZoomInputChange}
                className="zoom-percentage-input"
                min="0"
                max="300"
              />
              <button className="zoom-button" onClick={handleZoomIn}>
                +
              </button>
              <button className="rotate-button" onClick={handleRotate}>
                <MdOutlineRotate90DegreesCcw />
              </button>
            </div>

            <div className="image-container">
              <img
                src={selectedImage}
                alt="Selected"
                className="full-image"
                style={{
                  transform: `scale(${scale}) rotate(${rotation}deg)`,
                  transition: "transform 0.3s ease",
                }}
              />
            </div>
          </div>
        )}
        {/* <div className="fixed-buttons">
          <button
            className="prev-button"
            onClick={handlePrevious}
            disabled={currentIndex === 0}
          >
            <FaAngleLeft />
            {/* <span className="button-text">Prev</span> */}
        {/* </button>
          <button
            className="next-button"
            onClick={handleNext}
            disabled={currentIndex === userList?.length - 1}
          >
            <FaAngleRight /> */}
        {/* <span className="button-text">Next</span> */}
        {/* </button>
        </div> */}
      </Container>
    </React.Fragment>
  );
};
export default KycControls;
